import * as React from 'react';
import { KEY_DEFAULT_SEARCH_DEST_CODE, FormatterUtils } from '../core/Const';
import { HotelBedCatalogData, HotelBedData } from '../shared/index';
import { getAjaxhelper, getFromCacheOrRequestHotelCategoryCatalog, getOnlyFromCacheHotelCategoryCatalog, isNull, momentWrapper } from '../utils/index';
import { BaseHaveHotelSearchPanel, BaseHaveHotelSearchPanelProps, BaseHaveHotelSearchPanelState, REQ_AVAILABLE_PANEL_STATE } from './BaseHaveHotelSearchPanel';
import { HotelRequestCheckerTool } from './HotelRequestCheckerTool';
import { HotelsLeftSide, GlobalDataFilter } from './HotelsLeftSide';
import { HotelsMainContentWithBulkData } from './HotelsMainContentWithBulkData';
import { HotelsSearch } from './HotelsSearch';
import { NoPropertyIsAvailablePanel } from './NoPropertyIsAvailablePanel';
import { FirebaseRealtimeDbBasedHotelRequestCheckerTool } from './req-available/FirebaseRealtimeDbBasedHotelRequestCheckerTool'; 
import { Distinct } from 'src/utils/distinct-array';
import { Pagination } from 'src/core';
import { filterBudget, filterArea, filterFacilitiesHotel, filterSpecialHotel, filterStarHotel, filterTypeHotel, isiMobileFilter  } from './hotel-top-filter/index';  

export interface FilterSelected {
    DestinationZone: string;
    hotelName: string;
    AccomodationType: string;
    Category: string;
    HotelBoard: string;
    Facilities: string;
    Special: string;
    Segment: string;
    Interest: string;
    PriceRage: string;
}
export interface CurrenSelectedFilter {
    DestinationZone: number[];
    hotelName: number[];
    AccomodationType: number[];
    Category: number[];
    HotelBoard: number[];
    Facilities: number[];
    Special: number[];
    Segment: number[];
    Interest: number[];
    PriceRage: number[];
}
export interface HotelSearchResultWithUrlReqKeyMainPanelProps extends BaseHaveHotelSearchPanelProps {

    /** 
     * filter awal untuk data
     */
    initialFilter?: HotelBedData.SearchFilter;

    /** 
     * nilai awal untuk external filter
     */
    initialExternalFilter?: HotelBedData.ExternalFilter;

    /** 
     * size page per request
     */
    pageSize: number;

    /**
     * page yang active
     */
    initialPage?: number;

    wishlistCount: (c: number) => any;
    /** Perubahan jadi prop untuk query string */

    newRequestAvailability: (dari: string) => any;
    updateInternalFilter: (filter: HotelBedData.SearchFilter) => any;
    pesanAtas?: any;
    firebaseApp: firebase.app.App;
    pageChange: (page: number, dari: string) => any;
    page: number;
}
export interface HotelSearchResultWithUrlReqKeyMainPanelState extends BaseHaveHotelSearchPanelState {

    filterRateChange: boolean;
    page: number;
    maxRate: number;
    minRate: number;
    backTotalPage: number;
    filters: GlobalDataFilter;
    sortBy: string;
    budget: string;
    special: string;
    topArea: string;
    star: string;
    type: string;
    facilities: string;
    showMobileFilter: boolean;
    hotelCodesFilter?: number[];
    filterSelected: FilterSelected;
    currenSelectedFilter: CurrenSelectedFilter;
}
/**
 * Versi request available dengan req key di url. pengecekan time juga di lakukan di server
 * @author Gede Sutarsa
 */
export class HotelSearchResultWithUrlReqKeyMainPanel extends BaseHaveHotelSearchPanel<HotelSearchResultWithUrlReqKeyMainPanelProps, HotelSearchResultWithUrlReqKeyMainPanelState> {
    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['lang', 'currency', 'responKey'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ['hotels', 'page', 'error', 'errorMessage', 'panelState', 'totalRow', 'minRate', 'maxRate', 'sortBy', 'filterBy', 'showMobileFilter'];
    /**
     * checker request header
     */
    checkerRequestAvailable: HotelRequestCheckerTool;
    /**
     * panel sisi kiri
     */
    leftSidePanel: HotelsLeftSide;
    /**
     * Panel untuk list hotels
     */
    hotelMainPanel: HotelsMainContentWithBulkData;

    constructor(props: HotelSearchResultWithUrlReqKeyMainPanelProps) {
        super(props);

        // remov this for live
        // this.getAvailabolityDetail();
    }

    generateChecker(documentCheckpath: string) {
        var sudahMasukRender: boolean = false;
        this.checkerRequestAvailable = new FirebaseRealtimeDbBasedHotelRequestCheckerTool({
            checkPath: documentCheckpath,
            realtimeDb: this.props.realtimeDb,
            // firestoreDb: this.props.firestoreDb,
            uuid: this.props.uuid,
            onCheckComplete: (requestHeader: HotelBedCatalogData.ReqHotelAvailable) => {
                //
                if (this.state.panelState === "COMPLETE_CHECKING") {
                    return;
                }

                this.setStateHelperAsync(st => {
                    st.requestHeader = requestHeader;
                    st.panelState = 'COMPLETE_CHECKING';
                    st.requesting = false;
                    st.totalRow = requestHeader.detailCount!;
                    st.backTotalPage = requestHeader.detailCount!;
                }).then(d => {
                    //
                    this.hotelMainPanel.updatePanelState(this.state.panelState);
                    // this.getAvailabilityDetail(true);

                    if (this.props.fromSlug === 'promotions') {
                        let codes = JSON.parse(this.props.slugData!).codes;
                        getAjaxhelper().post(`/dynamics/hb-api/cms-promotions-new`, {
                            codes: codes,
                            reqKey: this.props.responKey
                        }).then(
                            (x: any) => {
                                let hotelCodes: any = Distinct(x.hotelCodes);
                                this.hotelMainPanel.updateFilter({ hotelCodes });

                            }).catch((exc) => {
                                console.error('error: ', exc);
                            });
                    } else {
                        // 
                        if (!sudahMasukRender) {
                            this.hotelMainPanel.onChangePage(0, "HotelSearchResultWithUrlReqKeyMainPanel onCheckComplete");
                            sudahMasukRender = true;
                        }
                    }
                });
                if (this.leftSidePanel) {
                    this.leftSidePanel.getData();
                }
            },
            onCheckResultError: (exc: any) => {
                this.setStateHelper(st => {
                    st.panelState = 'ERROR';
                    st.requesting = false;
                    this.hotelMainPanel.updatePanelState("ERROR");
                    st.errorMessage = exc.messsage;
                });
                if (this.leftSidePanel) {
                    this.leftSidePanel.getData();
                }
            },
            onRequestHeaderDataChange: (requestHeader: HotelBedCatalogData.ReqHotelAvailable) => {
                if (this.state.panelState === "COMPLETE_CHECKING") {
                    return;
                }
                this.setStateHelperAsync(st => {
                    let reqFlag = true;
                    let sttsPanel: REQ_AVAILABLE_PANEL_STATE = 'CHECKING_WITH_NO_DATA_READY';
                    if (requestHeader.statusCode === 'AVAILABLE' || requestHeader.statusCode === 'NOTAVAILABLE' || requestHeader.statusCode === 'COMPLETE-WITH-ERROR') {
                        reqFlag = false;
                        sttsPanel = 'COMPLETE_CHECKING';
                    } else if (requestHeader.statusCode === 'PARTIALY-AVAILABLE') {
                        sttsPanel = 'CHECKING_WITH_SOME_DATA_READY';
                    }
                    st.panelState = sttsPanel;
                    st.requesting = reqFlag;
                    st.requestHeader = requestHeader;
                    st.totalRow = requestHeader.detailCount!;
                    st.backTotalPage = requestHeader.detailCount!;
                }).then(d => {
                    // 
                    if (!this.props.fromSlug) {
                        if (this.hotelMainPanel) {
                            this.hotelMainPanel.updatePanelState(this.state.panelState);
                        }
                        // this.getAvailabilityDetail(true);
                        if (this.state.panelState === 'CHECKING_WITH_SOME_DATA_READY' || this.state.panelState === 'COMPLETE_CHECKING') {
                            /**
                             * TODO: Tanyakan Ke gede kenapa ada disini juga
                             */
                            if (!sudahMasukRender) {
                                this.hotelMainPanel.onChangePage(0, "HotelSearchResultWithUrlReqKeyMainPanel onRequestHeaderDataChange");
                                sudahMasukRender = true;
                            }
                            // this.hotelMainPanel.onChangePage(0, "HotelSearchResultWithUrlReqKeyMainPanel onRequestHeaderDataChange");
                        }

                        if (this.leftSideFilter && this.state.requestHeader && ['PARTIALY-AVAILABLE'].indexOf(this.state.requestHeader.statusCode!) >= 0) {
                            this.leftSidePanel.getData();
                        }
                    }

                });
            }

        });
    }

    componentDidMount() {
        this.invokeCheckStatusAndTriggerRequestIfExpired();
        if (!this.state.indexedCategoryData) {
            getFromCacheOrRequestHotelCategoryCatalog()
                .then(d1 => {
                    this.setStateHelper(st => {
                        st.indexedCategoryData = d1;
                        st.version += 1;
                    });
                }).catch(exc => {
                    console.error(`[HotelSearchResultMainPanelWithBulkData#componentDidMount] gagal membaca data hotel category. error: `, exc);
                });
        }
    }
    shouldComponentUpdate(nextProps: HotelSearchResultWithUrlReqKeyMainPanelProps, nextState: HotelSearchResultWithUrlReqKeyMainPanelState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(HotelSearchResultWithUrlReqKeyMainPanel.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(HotelSearchResultWithUrlReqKeyMainPanel.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps: HotelSearchResultWithUrlReqKeyMainPanelProps, prevState: HotelSearchResultWithUrlReqKeyMainPanelState) {
        if (prevProps.lang !== this.props.lang || prevProps.currency !== this.props.currency) {
            this.invokeCheckStatusAndTriggerRequestIfExpired();
        }
    }

    componentWillUnmount() {
        if (this.checkerRequestAvailable) {
            this.checkerRequestAvailable.stopChecker();
        }
    }
    render() {
        
        if (this.state.haveReactError) {// panggil bawaan
            return this.renderErrorPanel();
        }
        // console.log("filterSelected", this.state.filterSelected);
        return (
            <div className='container'>

                <div style={{ paddingTop: 140 }} />
                <HotelsSearch
                    key={this.props.responKey}
                    lang={this.props.lang}
                    count={this.props.pageSize}
                    currency={this.props.currency}
                    getHotels={this.props.getHotels}
                    externalFilter={this.hotelMainPanel && this.hotelMainPanel.state && this.hotelMainPanel.state.externalFilter ? this.hotelMainPanel.state.externalFilter : null!}
                    initialFilter={this.props.initialFilter!}
                />
                <div className='row'>
                    {this.renderNoHotelAvailable()}
                    {this.renderHotelListPanel()}
                    {this.renderWarningPanel()}

                    <HotelsLeftSide
                        ref={d => this.leftSidePanel = d as any}
                        key={this.state.leftPanelRequesting}
                        lang={this.props.lang}
                        count={this.props.pageSize}
                        getHotels={this.getAvailabilityDetailFiltered}
                        currency={this.props.currency}
                        responKey={this.props.responKey}
                        updateMinMax={this.updateMinMax}
                        globalDataFilter={this.lobalDataFilter}
                    // minRate={this.state.filterRate.minRate}
                    // maxRate={this.state.filterRate.maxRate}
                    />
                </div>
            </div>
        );
    }

    lobalDataFilter = (filters: GlobalDataFilter) => {
        this.setState({ filters });
    }

    protected updateMinMax = (min: number, max: number) => {
        this.setState({ minRate: min ? min : 0, maxRate: max ? max : 0 });
    }

    protected getAvailabilityDetailFiltered: (hotelCodes: number[], externalFilter: HotelBedData.ExternalFilter) => any = (hotelCodes: number[], externalFilter: HotelBedData.ExternalFilter) => {
        // let hotelCodes
        let totalRow = this.state.backTotalPage;
        if (hotelCodes.length > 0) {
            totalRow = hotelCodes.length;
        }
        this.setState(
            { totalRow, page: 0 },
            () => {
                this.hotelMainPanel.updateFilter({
                    hotelCodes: hotelCodes,
                    externalFilter: externalFilter
                });
            }
        );
    }
    /**
     * check req available status. kalau data ilang atau expired maka trigger request available
     */
    protected invokeCheckStatusAndTriggerRequestIfExpired: () => any = () => {
        getAjaxhelper().get(`/dynamics/req-available/status/${this.props.responKey}`)
            .then(d => {
                const hData: HotelBedCatalogData.ReqHotelAvailable = d.reqAvailable;
                const expFlag: 'NOT_EXPIRED' | 'EXPIRED' = d.headerExpiredFlag;
                if (expFlag === 'EXPIRED') {
                    this.setStateHelperAsync(st => {
                        // st.requesting = true  ; 
                    }).then(d2 => {
                        this.props.newRequestAvailability("Lebih dari 15 menit request");
                    });
                    return;
                }
                this.generateChecker(hData.notificationDocPath!);
                this.checkerRequestAvailable.runCheckWithReqAvailibilityHeaderData(hData);
                // ['REQUESTING' ,  'AVAILABLE'  , 'NOTAVAILABLE' ,  'PARTIALY-AVAILABLE'  , 'COMPLETE-WITH-ERROR'].indexOf(hData.statusCode) >= 0 ? 'DATA_READY_TO_DISPLAY' :  'CHECKING'

            })
            .catch(exc => {
                const errorCode: string = exc.errorCode ? exc.errorCode : exc.code;
                if (errorCode === 'DATA_NOT_FOUND') {
                    this.props.newRequestAvailability('no-available');
                    this.setStateHelper(st => {
                        st.panelState = 'ERROR';
                        st.requesting = false;
                        st.errorMessage = `Header not found for request key ${this.props.responKey}`;
                    });
                    return;
                }
                this.setStateHelper(st => {
                    st.panelState = 'ERROR';
                    st.requesting = false;
                    st.errorMessage = exc.messsage;
                });
            });
    }
    protected generateState(): HotelSearchResultWithUrlReqKeyMainPanelState {
        const props = this.props;
        let defFilter: HotelBedData.SearchFilter = this.props.initialFilter!;
        if (isNull(defFilter)) {
            defFilter = {
                stay: {
                    checkIn: momentWrapper().add(1, 'days'), // moment(),
                    checkOut: momentWrapper().add(3, 'days'), // moment().add(1 , 'days')
                },
                occupancies: [{
                    rooms: 1,
                    adults: 2,
                    children: 0
                }],
                destination: {
                    id: 30, code: window[KEY_DEFAULT_SEARCH_DEST_CODE], zone: 0
                }
            };
        }
        let sCurrentFilter: any = isNull(props.initialFilter) ? defFilter : props.initialFilter;
        // let fils = sessionStorage.getItem(SESSION_STORAGE_AVAILABILITY_FILTER);
        let hotelCodes = null!;
        return {
            version: 1,
            currentFilter: sCurrentFilter,
            errorMessage: null!,
            hotelCodes: hotelCodes,
            filterRateChange: false,
            filterRate: {
                maxRate: 100000000,
                minRate: 0
            },
            indexedCategoryData: getOnlyFromCacheHotelCategoryCatalog(),
            leftPanelRequesting: 'lefpanelRequest',
            requestHeader: null!,
            panelState: 'INITIAL_CHECKING',
            requesting: true,
            totalRow: 0,
            page: this.props.page ?  this.props.page  : 0,
            maxRate: 0,
            minRate: 0,
            backTotalPage: 0,
            filters: {
                DestinationZone: [],
                hotelName: [],
                AccomodationType: [],
                Category: [],
                HotelBoard: [],
                Facilities: [],
                Special: [],
                Segment: [],
                Interest: [],
                PriceRage: []
            }, sortBy: '', budget: '', special: '', topArea: '', star: '', type: '', facilities: '',
            order: 'hbOrder', orderAsc: 'ASC', showMobileFilter: false,
            filterSelected: {
                DestinationZone: '',
                hotelName: '',
                AccomodationType: '',
                Category: '',
                HotelBoard: '',
                Facilities: '',
                Special: '',
                Segment: '',
                Interest: '',
                PriceRage: ''
            },
            currenSelectedFilter: {
                DestinationZone: [],
                hotelName: [],
                AccomodationType: [],
                Category: [],
                HotelBoard: [],
                Facilities: [],
                Special: [],
                Segment: [],
                Interest: [],
                PriceRage: [],
            }
        };
    }
    protected leftSideFilter: (externalFilter: HotelBedData.ExternalFilter) => any = (externalFilter: HotelBedData.ExternalFilter) => {
        this.props.getHotels(this.props.lang, 1, this.props.pageSize, this.state.currentFilter, externalFilter);
    }

    /**
     * ini untuk render kalau tidak ada hotel yang match
     */
    private renderNoHotelAvailable(): JSX.Element {
        if (!this.state.requestHeader || this.state.requestHeader.statusCode !== 'NOTAVAILABLE') {
            return <input type='hidden' key='no_prop_available_spacer' id='no_prop_available_spacer' />;
        }
        return (<NoPropertyIsAvailablePanel key='no_prop_available_spacer' />);
    }

    /**
     * renderpanel warning
     */
    private renderWarningPanel(): JSX.Element {
        if (this.state.panelState === 'ERROR') {
            return (
                <div className="col-md-9  col-md-push-3 ">
                    <div className="alert alert-warning"> {this.state.errorMessage}</div>
                </div>
            );
        }
        return <input type='hidden' key='error_spacer' id='error_spacer' />;
    }
    /**
     * renderer hotel list. setelah hotel available
     */
    private renderHotelListPanel(): JSX.Element {
        let pesanAtas: any[] = [];
        if (this.props.pesanAtas) {
            pesanAtas.push(this.props.pesanAtas);
            pesanAtas.push(<div className='row' />);
        }
        let hotelPount = (
            <div role="alert" className="alert alert-success" style={{ marginBottom: 5 }} >
                <strong>{this.state.totalRow} Property found</strong> start from {this.props.currency} {new FormatterUtils().formatMoney(this.state.minRate, this.props.currency, true, false)} until {new FormatterUtils().formatMoney(this.state.maxRate, this.props.currency, true, false)} / Room <span style={{ float: 'right' }}>page {this.state.page! + 1} </span>
            </div>
        );
        let topFilter: any[] = [];
         
        topFilter.push(
            <div className="top-filter btn-group btn-group-justified desktop-only" style={{ marginBottom: 5 }}>
                {this.sortByPrice()}
                {filterBudget(this.state.filters.PriceRage, this.getAvailabilityDetailFiltered, this,  this.state.filterSelected, this.state.currenSelectedFilter)}
                {filterSpecialHotel(this.state.filters.Special, this.getAvailabilityDetailFiltered, this,  this.state.filterSelected, this.state.currenSelectedFilter)}
                {filterArea(this.state.filters.DestinationZone, this.getAvailabilityDetailFiltered, this,  this.state.filterSelected, this.state.currenSelectedFilter)}
                {filterStarHotel(this.state.filters.Category, this.getAvailabilityDetailFiltered, this,  this.state.filterSelected, this.state.currenSelectedFilter)}
                {filterTypeHotel(this.state.filters.Segment, this.getAvailabilityDetailFiltered, this,  this.state.filterSelected, this.state.currenSelectedFilter)}
                {filterFacilitiesHotel(this.state.filters.Facilities, this.getAvailabilityDetailFiltered, this,  this.state.filterSelected, this.state.currenSelectedFilter)}
            </div>
        );
        topFilter.push(
            <div className="top-filter btn-group btn-group-justified desktop-only mobile-only" style={{ marginBottom: 5 }}>
                {this.mobilePrice()}
                {this.mobileFilter()}
                {this.mobileMap()}
            </div>
        );
        topFilter.push(
            <div className="row mobile-only" style={{ marginBottom: 5 }} />
        );
        // console.log("mobilefilter", this.state.showMobileFilter);
        // console.log("New All Filter", JSON.stringify(this.state.currenSelectedFilter));
        let mobileFilter =  isiMobileFilter(this.state.showMobileFilter, this.state.filters, this.getAvailabilityDetailFiltered, this, this.state.filterSelected, this.state.currenSelectedFilter);
        // console.log("mobileFilter", mobileFilter);
        return (
            <div className="col-md-9  col-md-push-3">
                {pesanAtas} 
                {hotelPount}
                {topFilter}
                {mobileFilter}
                {this.state.hotelCodesFilter && this.state.hotelCodesFilter!.length === 0 ? this.PropertyNotonFilter() : <span/>}
                <HotelsMainContentWithBulkData
                    ref={d => this.hotelMainPanel = d as any} 
                    lang={this.props.lang}
                    currency={this.props.currency}
                    history={this.props.history}
                    initialFilter={this.state.currentFilter}
                    wishlistCount={this.props.wishlistCount}
                    indexedCategoryData={this.state.indexedCategoryData}
                    responKey={this.props.responKey}
                    firebaseApp={this.props.firebaseApp}
                    updateMinMax={this.updateMinMax}
                    page={this.state.page}
                />
                <Pagination key='pagination' page={this.state.page} pageSize={15} totalCount={this.state.totalRow!} onChangePage={this.onChangePage} />
            </div>

        );
    }

    private PropertyNotonFilter = () => {
        return (
            <div> 
                <div className="row"/> 
                <div className="alert alert-danger" style={{textAlign: 'center', padding: 30}}>
                    <i className="fa fa-exclamation-triangle" style={{fontSize: 72}}/> <br/>
                    <h5>Currently we can't find what your looking for. You can email us your request to info@balihotelsandmore.com and we can help find you the very best Bali hotel specials</h5> 
                </div> 
            </div>
        );
    }
    private mobileFilter = () => {
        return (
            <div className="btn-group btn btn-primary" style={{ textAlign: 'center' }}>
                <a
                    href="javascript:void(0)"
                    style={{ color: '#fff' }}
                    onClick={
                        () => {
                            this.setStateHelper(
                                st => {
                                    st.showMobileFilter = st.showMobileFilter ? false : true;
                                }
                            );
                        }
                    }
                >
                    Filter <i className="fa fa-filter" />
                </a>

            </div>
        );
    }

    private mobileMap = () => {
        return (
            <div className="btn-group btn btn-primary" style={{ textAlign: 'center' }}>
                <a href={`/maps?rk=${this.props.responKey}`} style={{ textAlign: 'center', color: '#fff' }} target="_blank" >
                    Map View
                </a>
            </div>
        );
    }

    private mobilePrice = () => {
        return (
            <div className="btn btn-group btn-primary" style={{ textAlign: 'center', color: '#fff' }}>
                <a
                    onClick={
                        () => {
                            this.setStateHelper(
                                st => {
                                    st.sortBy = " (Min - Max)";
                                    st.page = 0;
                                },
                                () => {
                                    this.hotelMainPanel.getAvailabilitysSorted('net', 'ASC');
                                }
                            );
                        }
                    }
                    style={{ color: '#fff' }}
                > Min - Max
                </a>
            </div>
        );
    }

    private sortByPrice = () => {
        return (
            <div className="btn-group" style={{ border: '1px solid #fff' }}>
                <a href="javascript:void(0)" data-toggle="dropdown" style={{ color: "#fff" }} className="btn btn-squared btn-primary  dropdown-toggle" aria-expanded="true">
                    {this.state.sortBy === "" ? 'Sorted by' : this.state.sortBy}<span className="caret" />
                </a>
                <ul className="dropdown-menu dropdown-dark pull-right" role="menu">
                    <li>
                        <a
                            onClick={
                                () => {
                                    this.setStateHelper(
                                        st => {
                                            st.sortBy = " (Min - Max)";
                                            st.page = 0;
                                        },
                                        () => {
                                            this.hotelMainPanel.getAvailabilitysSorted('net', 'ASC');
                                        }
                                    );
                                }
                            }
                        > Min - Max
                        </a>
                    </li>
                    <li>
                        <a
                            onClick={
                                () => {
                                    this.setStateHelper(
                                        st => {
                                            st.sortBy = " (Max - Min)";
                                            st.page = 0;
                                        },
                                        () => {
                                            this.hotelMainPanel.getAvailabilitysSorted('net', 'DESC');
                                        }
                                    );
                                }
                            }
                        > Max - Min
                        </a>
                    </li>
                </ul>
            </div>

        );
    } 
    onChangePage: (data: number, dari: string) => any = (data: number, dari: string) => {
        // 
        this.props.pageChange(data, "dari Search Result");
    }
    
    actionChangePage: (data: number, dari: string) => any = (data: number, dari: string) => {
        // this.hotelMainPanel.onChangePage(data, dari); 
        this.setState({ page: data }, () => { this.hotelMainPanel.onChangePage(data, dari); });
    }
} 


// WEBPACK FOOTER //
// ./src/hotels/HotelSearchResultWithUrlReqKeyMainPanel.tsx